import Vue from 'vue'
import Vuex from 'vuex'
import { SET_LANG, SET_LOGIN_USER, SET_STATE_CODE_LIST } from '@/store/mutation-types'
import createPersistedState from 'vuex-persistedstate'
import { getStateCodeList } from "@/api/airwayBill";
Vue.use(Vuex)


const state = {
  lang: 'en',
  langs: ['zh-cn', 'zh-tw', 'en'],
  user: null,
  cache: {
    stateCodeList: [] //状态代码集合
  }
};

export default new Vuex.Store({
  plugins: [createPersistedState({
    //需要持久化的数据
    reducer (val) {
      return {
        lang: val.lang,
        user: val.user,
      }
    }
  })],
  state,
  getters: {
    token: state => state.user === null ? '' : state.user.token,
    lang: state => state.lang,
    user: state => state.user,
    cache: state => state.cache
  },
  mutations: {
    /**
     * 设置语言信息
     * @param {*} state 
     * @param {*} lang 
     */
    [SET_LANG] (state, lang) {
      if (state.langs.indexOf(lang) == -1) {
        state.lang = 'en';
      }
      else {
        state.lang = lang;
      }
    },
    [SET_LOGIN_USER] (state, user) {
      state.user = user;
    },
    [SET_STATE_CODE_LIST] (state, stateCodeList) {
      state.cache.stateCodeList = stateCodeList;
    }
  },
  actions: {
    async fetchStateCodeListAsync ({ commit, state }) {
      if (state.cache.stateCodeList.length === 0) {
        await getStateCodeList().then((res) => {
          commit(SET_STATE_CODE_LIST, res.data === null ? [] : res.data);
        });
      }

      return state.cache.stateCodeList;
    }
  }
})
